/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { TVisitor } from "apis/visitors/type";
import { theme } from "styles/theme";

import StateTag from "../state-tag";
import { useState } from "react";
import ChangeVisitStatusModal from "../../modal/change-visit-status-modal.tsx";
import ReSendMessageModal from "../../modal/re-send-message-modal";
import SendStateTag from "../send-state";

const ItemContainer = styled.div`
  display: flex;
  padding: 16px 24px;
  gap: 10px;
  align-items: center;
  border-bottom: 1px solid ${theme.neutral100};
`;

const WidgetContainer = styled.div<{ width: number }>`
  width: ${(props) => props.width + "px"};
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.neutral900};
`;

const ReSendBtn = styled.p`
  color: ${theme.primary500};
  font-weight: 600;
  font-size: 14px;
  margin-left: auto;

  cursor: pointer;

  &:hover {
    font-weight: 800;
  }
`;

export const Item = ({
  visitor,
  onHandleSend,
  onChangeState,
  isPlannedVisit = false,
}: {
  visitor: TVisitor;
  onHandleSend: () => void;
  onChangeState?: () => void;
  isPlannedVisit?: boolean;
}) => {
  const state = visitor.visitorStatus ? visitor.visitorStatus : "UPCOMING";
  const [open, setOpen] = useState<boolean>(false);
  const [sendModal, setSendModal] = useState<boolean>(false);

  return (
    <ItemContainer>
      <WidgetContainer width={100}>{visitor.name}</WidgetContainer>
      <WidgetContainer width={158}>
        {visitor.guideChannel === "EMAIL" ? visitor.email : visitor.phoneNumber}
      </WidgetContainer>
      <WidgetContainer
        width={100}
        css={css`
          color: ${visitor.acceptTerm ? theme.primary500 : "#FF3E3E"};
        `}
      >
        {visitor.acceptTerm ? "동의" : "미동의"}
      </WidgetContainer>

      <WidgetContainer
        width={140}
        css={css`
          overflow: visible;
        `}
      >
        <StateTag
          state={state}
          allowSelect={visitor.acceptTerm && !isPlannedVisit}
          onChangeState={(value) => {
            if (value === "방문 완료") {
              setOpen(true);
            }
          }}
        />
      </WidgetContainer>
      <WidgetContainer width={80}>{visitor.guideChannel.toLowerCase()}</WidgetContainer>
      <WidgetContainer width={82}>
        <SendStateTag state={visitor?.isGuideMessageSent} />
      </WidgetContainer>
      {!visitor?.isGuideMessageSent &&
        !(visitor.visitorStatus === "MISSED_CHECK_OUT") &&
        !(visitor.visitorStatus === "NOT_VISITED") && <ReSendBtn onClick={() => setSendModal(true)}>재전송</ReSendBtn>}
      <ChangeVisitStatusModal
        modalIsOpen={open}
        closeModal={() => setOpen(false)}
        title={`${visitor.name}님을 방문 완료 처리하시겠습니까?`}
        onHandleConfirm={async () => {
          onChangeState?.();
          setOpen(false);
        }}
        description={
          <p>
            태블릿에서 체크인/체크아웃을 하지 않은 경우
            <br />
            미방문/체크아웃 누락 상태일 수 있습니다.
          </p>
        }
      />
      <ReSendMessageModal
        onHandleSend={onHandleSend}
        closeModal={() => setSendModal(false)}
        modalIsOpen={sendModal}
        visitor={visitor}
      />
    </ItemContainer>
  );
};

export default Item;
